import * as actionTypes from '../../constants/actionTypes';

export const updateSearchFilters = (view, filters) => {
  return {
    type: actionTypes.UPDATE_SEARCH_FILTERS,
    payload: {
      view,
      filters,
    },
  };
};

export const clearResourceSuggestions = () => {
  return {
    type: actionTypes.CLEAR_RESOURCE_SUGGESTIONS,
  };
};
